import React, { ReactNode } from "react";
import { useAppSelector } from "../../redux/hooks/hooks";
import { selectProtectionType, selectUserFunctions } from "../../redux/feature/settings/configurations-slice";
import { UserFunction } from "../../api/models/user-function";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { DISABLED } from "../../utils/user-function/userFunctionUtils";
import { OperationCompletedPanel } from "../layout/OperationCompletedPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

interface ProtectedComponentInterface {
  children: ReactNode;
  userFunction?: UserFunctionEnum;
  errorComponent?: ReactNode;
  protectionType?: boolean;
}

export const ProtectedComponent: React.FunctionComponent<ProtectedComponentInterface> = (props) => {
  const userFunctions: UserFunction[] = useAppSelector(selectUserFunctions);
  const protectionType: number = useAppSelector(selectProtectionType);
  const children = props.children;
  const userFunction = props.userFunction;
  const errorComponent = props.errorComponent;
  let isReadOnly: boolean;
  const userFunctionsEnum: UserFunctionEnum[] = [];
  userFunctionsEnum.push(UserFunctionEnum.MENU_OPEN);
  userFunctionsEnum.push(UserFunctionEnum.MENU_NEW_DOCUMENT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_IMPORT_DOCUMENT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_NEW_OBJECT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_EDIT_OBJECT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_SYNCHRONIZE);
  userFunctionsEnum.push(UserFunctionEnum.MENU_MOVE_OBJECT);

  let userFunctionsMap = new Map<string, boolean>();
  userFunctionsEnum.forEach((value) => userFunctionsMap.set(value.toString(), false));
  if (userFunctions) {
    userFunctions.forEach((func: UserFunction) => {
      if (func.action !== DISABLED) {
        userFunctionsMap.set(func.function, true);
      }
    });
    if (userFunctions.length !== 0) {
      userFunctionsMap.set(UserFunctionEnum.MENU_OPEN, true);
    }
  }
  if (props.protectionType && protectionType === 3) {
    isReadOnly = true;
  }
  if (isReadOnly && (userFunction ? userFunctionsMap.get(userFunction?.toString()) : true)) {
    return (
      <OperationCompletedPanel
        message={formatMessage("cof.access.message.error.readonly")}
        alt={formatMessage("cof.access.message.error.readonly")}
        icon="/assets/Unauthorized.svg"
      />
    );
  }

  return <>{(userFunction ? userFunctionsMap.get(userFunction?.toString()) : true) ? children : errorComponent}</>;
};
